<template>
  <svg viewBox="0 0 22 17"><path fill-rule="nonzero" d="M19.8 11.733c0-4.106-2.86-7.626-6.82-8.58a2.03 2.03 0 00.22-.953C13.2.953 12.247 0 11 0 9.753 0 8.8.953 8.8 2.2c0 .367.073.66.22.953-3.96.954-6.82 4.474-6.82 8.58-1.247 0-2.2.954-2.2 2.2 0 1.247.953 2.2 2.2 2.2h17.6c1.247 0 2.2-.953 2.2-2.2 0-1.246-.953-2.2-2.2-2.2zM11 1.467c.44 0 .733.293.733.733s-.293.733-.733.733-.733-.293-.733-.733.293-.733.733-.733zM11 4.4c4.033 0 7.333 3.3 7.333 7.333H3.667C3.667 7.7 6.967 4.4 11 4.4zm8.8 10.267H2.2c-.44 0-.733-.294-.733-.734s.293-.733.733-.733h17.6c.44 0 .733.293.733.733s-.293.734-.733.734z" /></svg>
</template>

<script>
export default {
  name: 'Dish'
}
</script>
